/**
 * IMPORTS
 */

import { IAtualizarTiposEntregaPayload } from "@/hooks/tipos-entregas/atualizar-tipo-entrega-usuario/index.d";

import { tiposEntregaRepository } from "@/repositories/tipos-entregas";

/**
 * Função que busca dados tipos de entrega 🛠️.
 */
const handleGetTiposEntregas = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await tiposEntregaRepository.getAllTiposEntrega(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR TIPOS DE ENTREGAS: ", error);
    return error;
  }
};

/**
 * Função que criar dados tipos de entrega 🛠️.
 */
const handleCriarNovoTiposEntrega = async (accessToken: string, payload: any) => {
  try {
    const data = await tiposEntregaRepository.criarNovoTiposEntrega(accessToken, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR EM REGISTRAR TIPOS DE ENTREGAS: ", error);
    return error;
  }
};

/**
 * Função que vincula tipos de entrega ao usuario 🛠️.
 */
const handleVincularTiposEntregaUsuario = async (accessToken: string, payload: any) => {
  try {
    const data = await tiposEntregaRepository.vincularTiposEntregaUsuario(accessToken, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR EM REGISTRAR TIPOS DE ENTREGAS: ", error);
    return error;
  }
};
/**
 * Função que atualizar tipos de entrega ao usuario 🛠️.
 */
const handleAtualizarTiposEntregaUsuario = async (
  accessToken: string,
  payload: IAtualizarTiposEntregaPayload
) => {
  try {
    const data = await tiposEntregaRepository.atualizarTiposEntregaUsuario(accessToken, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR EM ATUALIZAR TIPOS DE ENTREGAS: ", error);
    return error;
  }
};

/**
 * EXPORTS
 */
export {
  handleAtualizarTiposEntregaUsuario,
  handleCriarNovoTiposEntrega,
  handleGetTiposEntregas,
  handleVincularTiposEntregaUsuario,
};
